import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import { FiArrowLeft } from 'react-icons/fi';
import api from '../services/api';

const JobsDetail = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const response = await api.get(`/jobs/${id}`);
        setJob(response.data.data);
      } catch (err) {
        console.error('Failed to fetch job:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchJob();
  }, [id]);

  if (loading) {
    return (
      <LoadingContainer>
        <LoadingText>Loading job...</LoadingText>
      </LoadingContainer>
    );
  }

  if (!job) {
    return (
      <ErrorContainer>
        <ErrorText>Job not found</ErrorText>
        <BackLink to="/jobs">
          <FiArrowLeft /> Back to Job History
        </BackLink>
      </ErrorContainer>
    );
  }

  return (
    <DetailContainer>
      <Container>
        <BackLink to="/jobs">
          <FiArrowLeft /> Back to Job History
        </BackLink>
        <Header>
          <CategoryBadge>{job.category}</CategoryBadge>
          <Title>{job.title}</Title>
          {job.shortDescription && <Description>{job.shortDescription}</Description>}
          {job.description && <DetailDescription>{job.description}</DetailDescription>}
        </Header>
      </Container>
    </DetailContainer>
  );
};

const DetailContainer = styled.div`min-height:100vh; padding:3rem 0;`;
const Container = styled.div`max-width:800px; margin:0 auto; padding:0 2rem;`;
const LoadingContainer = styled(Container)`display:flex; justify-content:center; align-items:center; height:50vh;`;
const LoadingText = styled.p`font-size:1.25rem; color:var(--text-secondary);`;
const ErrorContainer = styled(Container)`display:flex; flex-direction:column; align-items:center; justify-content:center; height:50vh; gap:1rem;`;
const ErrorText = styled.p`font-size:1.25rem; color:var(--accent-primary);`;
const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary);
  margin-bottom: 2rem;
  transition: color 0.3s ease;
  &:hover {
    color: var(--accent-primary);
  }
`;
const Header = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const CategoryBadge = styled.span`
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--accent-gradient);
  color: white;
  border-radius: 2rem;
  font-size: 0.875rem;
  text-transform: uppercase;
`;
const Title = styled.h1`
  margin: 0;
  font-size: 2rem;
`;
const Description = styled.p`
  font-size: 1.125rem;
  color: var(--text-secondary);
  line-height: 1.6;
`;
const DetailDescription = styled.p`
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-top: 0.5rem;
`;

export default JobsDetail;
